import axios from "axios";
import router from "../router/index";
import $ from "jquery";
import { Message } from "element-ui";
import _ from "lodash";
import Vue from "vue";
const subscription = {
  state: () => ({
    subscriptionPlanList: [],
    subscriptionCategories: [],
    activeSubscription: {},
    validationErrors: [],
    paymentMethods: [],
    paymentHistory: {
      items: []
    },
    overviewSubscription: null,
    additionalPlans: [],
    activeStorageSubscription: null,
    activeTeamMemberSubscription: null,
    subscriptionPermissions: null
  }),
  mutations: {
    setSubscriptionAdditionalPlans(state, payload) {
      state.additionalPlans = payload;
    },
    setSubscriptionCategoryList(state, payload) {
      state.subscriptionCategories = payload;
    },
    setSubscriptionPlansList(state, payload) {
      state.subscriptionPlanList = payload;
    },
    setActiveTeamMemberSubscription(state, payload) {
      state.activeTeamMemberSubscription = payload;
    },
    setActiveStorageSubscription(state, payload) {
      state.activeStorageSubscription = payload;
    },
    setActiveSubscription(state, payload) {
      state.activeSubscription = payload;
    },
    setSubscriptionValidation(state, payload) {
      state.validationErrors = payload;
    },
    setPaymentMethods(state, payload) {
      state.paymentMethods = payload;
    },
    setPaymentHistory(state, payload) {
      state.paymentHistory = payload;
    },
    setSubscriptionOverview(state, payload) {
      state.overviewSubscription = payload;
      if (payload.currentPlan != null) {
        var combinedObject = {};
        payload.currentPlan.values.forEach(item => {
          var key = item.key.replace(/-([a-z])/g, function(match, letter) {
            return letter.toUpperCase();
          });
          key = key.replaceAll("-", "");
          combinedObject[key] = item.value == "fa-check-gray" ? false : item.value == "fa-check" ? true : item.valueCount;

          // Object.keys(item).forEach((key) => {
          //   if (key == "ID" || key == "CreatedDateTime" || key == "UpdatedDateTime" || key == "Title") {
          //     return;
          //   }
          //   const newKey = item.key + `${key.charAt(0).toUpperCase()}${key.slice(1)}`;
          //   combinedObject[newKey] = combinedObject[newKey] || [];
          //   combinedObject[newKey] = item[key];
        });
        state.subscriptionPermissions = combinedObject;
      }
    }
  },
  actions: {
    async subscriptionRedeemCode(store, payload) {
      var res = await axios.post("/Subscription/RedeemAnotherAppsumoCode", { code: payload });
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
      }
      return res;
    },
    async getSubscriptionInvoiceUrl(context, payload) {
      var res = await axios.post("/Subscription/GetInvoiceUrl", { objectKey: payload });
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      }
      return res;
    },
    async subscriptionValidationCouponCode(context, payload) {
      var res = await axios.post("/Subscription/ValidateCouponCodeQuery", payload);
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
      }
      return res;
    },
    async resetPaymentMethodErrorCount(context, payload) {
      var res = await axios.post("/Subscription/ResetPaymentMethodErrorCount", payload);
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
      }
    },
    async getSubscriptionAdditionalPlans(context) {
      var res = await axios.post("/Subscription/ListAdditionalPlans");
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        var additionalPlanMap = res.data.data.items.map(x => {
          x = {
            ...x,
            count: 1
          };
          return x;
        });
        context.commit("setActiveTeamMemberSubscription", res.data.data.activeTeamMemberSubscription);
        context.commit("setActiveStorageSubscription", res.data.data.activeStorageSubscription);
        context.commit("setSubscriptionAdditionalPlans", additionalPlanMap);
      }
    },
    async subscriptDeletePaymentMethod(context, payload) {
      var res = await axios.post("/Subscription/DeletePaymentMethod", { id: payload });
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
        context.dispatch("getPaymentMethods");
      }
    },
    async cancelSubscription(context, payload) {
      var res = await axios.post("/Subscription/CancelSubscription", { id: payload });
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
        context.dispatch("getSubscriptionPlanList");
        context.dispatch("getSubscriptionAdditionalPlans");
      }
    },
    async cancelCancelSubscription(context, payload) {
      var res = await axios.post("/Subscription/CancelCancelSubscription", { id: payload });
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
        context.dispatch("getSubscriptionPlanList");
        context.dispatch("getSubscriptionAdditionalPlans");
      }
    },
    async startWithCardSubscription(context, payload) {
      var res = await axios.post("/Subscription/StartSubscriptionWithCard", payload);
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
      }
      return res;
    },
    async buyAdditionalPackage(context, payload) {
      var res = await axios.post("/Subscription/BuyAdditionalPackage", payload);
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
        context.dispatch("getSubscriptionAdditionalPlans");
      }
      return res;
    },
    async buyAdditionalPackageWithCard(context, payload) {
      var res = await axios.post("/Subscription/BuyAdditionalPackageWithCard", payload);
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
        context.dispatch("getSubscriptionAdditionalPlans");
      }
      return res;
    },
    async getSubscriptionOverview(context) {
      var res = await axios.post("/Subscription/Overview");
      console.log(res.data.data);
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        context.commit("setSubscriptionOverview", res.data.data);
        context.commit("setActiveSubscription", res.data.data.subscription);
      }
    },
    async getPaymentHistory(context, payload) {
      var res = await axios.post("/Subscription/PaymentHistory", { ...payload, skip: (payload.page - 1) * payload.take });
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        context.commit("setPaymentHistory", res.data.data);
      }
    },
    async setPrimaryCard(context, payload) {
      var res = await axios.post("/Subscription/MakePrimaryCard", { id: payload });
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
        context.dispatch("getPaymentMethods");
      }
    },
    async getPaymentMethods(context) {
      var res = await axios.post("/Subscription/PaymentMethods");
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        context.commit("setPaymentMethods", res.data.data.items);
      }
    },
    async getSubscriptionPlanList(context) {
      var res = await axios.post("/Subscription/ListPlans");
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        context.commit("setSubscriptionPlansList", res.data.data.items);

        var categoryList = [];
        res.data.data.categories.forEach(x => {
          var payload = {
            title: x,
            isOpen: false,
            subCat: []
          };
          categoryList.push(payload);
        });

        categoryList = categoryList.map(x => {
          res.data.data.items.forEach(y => {
            var totalCat = [];
            totalCat = y.values.filter(c => c.category == x.title);

            if (totalCat.length > 0) {
              x.subCat.push(...totalCat);
            }
          });

          x.subCat =
            x.subCat.length > 0
              ? x.subCat.map(g => {
                  return { title: g.title, description: g.description };
                })
              : [];
          x.subCat = x.subCat.length > 0 ? [...new Set(x.subCat)] : [];
          x.subCat = _.uniqWith(x.subCat, _.isEqual);
          // x.subCat = _.uniqWith(
          //   _.filter(x.subCat, (item) => item.description),
          //   _.isEqual
          // );
          return x;
        });
        categoryList[0].isOpen = true;

        context.commit("setSubscriptionCategoryList", categoryList);
      }
    },
    async startSubscription(context, payload) {
      var res = await axios.post("/Subscription/StartSubscription", payload);
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
        context.dispatch("getSubscriptionPlanList");
      }
      return res;
    },
    async updateBillingInfo(context, payload) {
      var res = await axios.post("/Subscription/UpdateBillingInfo", payload);
      context.commit("setSubscriptionValidation", res.data.validationErrors);
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
      }
      return res;
    }
  },
  getters: {
    getSubscriptionPlanList: state => state.subscriptionPlanList,
    getActiveSubscription: state => state.activeSubscription,
    getActiveTeamMemberSubscription: state => state.activeTeamMemberSubscription,
    getActiveStorageSubscription: state => state.activeStorageSubscription,
    getSubscriptionValidation: state => state.validationErrors,
    getPaymentMethods: state => state.paymentMethods,
    getSubscriptionPaymentHistory: state => state.paymentHistory,
    getSubscriptionOverview: state => state.overviewSubscription,
    getSubscriptionCategories: state => state.subscriptionCategories,
    getSubscriptionAdditionalPlans: state => state.additionalPlans,
    getSubscriptionPermission: state => state.subscriptionPermissions
  }
};
export default subscription;



// WEBPACK FOOTER //
// ./src/store/subscription.js